import React from 'react';
import useSectionViewTracking from '../hooks/useSectionViewTracking';
import styles from './PartnershipsSection.module.css';

const partnerCards = [
  {
    id: 1,
    title: 'For Publishers & Licensing Partners',
    primary: true,
    items: [
      'Sell sheets, rules overview, and production specs available',
      'Licensing, localization, and market discussions',
      'Manufacturing and production readiness',
    ],
    email: 'publishers@stratmechstudios.com',
    buttonLabel: 'Discuss a Partnership',
  },
  {
    id: 2,
    title: 'For Retailers & Distributors',
    primary: false,
    items: [
      'Wholesale availability upon release',
      'Retail-ready packaging and shelf presence',
      'Early stock and allocation discussions',
    ],
    email: 'retail@stratmechstudios.com',
    buttonLabel: 'Retail Inquiries',
  },
  {
    id: 3,
    title: 'For Board Game Cafes & Community Spaces',
    primary: false,
    items: [
      'Demo copies and preview opportunities',
      'Organized play and launch event support',
      'Cafe-friendly play guidance',
    ],
    email: 'community@stratmechstudios.com',
    buttonLabel: 'Community Partnerships',
  },
];

export default function PartnershipsSection() {
  const sectionRef = useSectionViewTracking('partnerships');

  return (
    <section ref={sectionRef} className={styles.partnerships} id="partner">
      <div className={styles.container}>
        <h2 className={styles.title}>Partner With StratMech Studios</h2>
        <p className={styles.subtitle}>
          Working with publishers, retailers, and community partners to bring thoughtful strategy games to the table.
        </p>

        <div className={styles.grid}>
          {partnerCards.map((card) => (
            <article key={card.id} className={`${styles.card} ${card.primary ? styles.cardPrimary : ''}`}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <ul className={styles.cardList}>
                {card.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              <div className={styles.cardActions}>
                <button className={styles.cardButton} type="button" disabled>
                  {card.buttonLabel}
                </button>
                <span className={styles.cardEmail}>{card.email}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
